import { render, staticRenderFns } from "./SuratKetMedis.vue?vue&type=template&id=0a867662&"
import script from "./SuratKetMedis.vue?vue&type=script&lang=js&"
export * from "./SuratKetMedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports